module.exports = __webpack_public_path__ + "static/media/iovlabs.7edc31b0.jpg";